import React from "react";
import NamedResourceForm from "../../curriculum/components/named-resource-form";
import {cvQualificationService} from "../../../services/curriculum-resource-service";

const CvQualificationForm = () => (
    <NamedResourceForm singularTitle="Capacitação" article="a" basePath="/cv/qualification"
                       queryKey="cv-qualifications" service={cvQualificationService}/>
);

export default CvQualificationForm;
